import { createPortal } from 'react-dom';

// 2026-10-22 (fase 2): ticket térmico de 80 mm de un comprobante de caja RI (ingreso) o RE
// (egreso), con firmas de quien entrega y quien recibe. Mismo estilo que TicketImprimible.
export const NOMBRE_CAJA: Record<string, string> = {
  ventas: 'Caja Repuestos (ventas)', servicios: 'Caja Servicios', mantenimiento: 'Caja Mantenimiento', chica: 'Caja Chica (gastos y compras)',
};

export interface ComprobanteCaja {
  numero: string; tipo: 'RI' | 'RE'; caja: string | null; monto: number | string; metodo_pago: string | null;
  concepto: string | null; categoria: string | null; usuario: string | null; fecha: string;
  anulado: boolean; anulado_en?: string | null; anulado_por?: string | null; anulado_motivo?: string | null;
}

const ComprobanteTicket = ({ c }: { c: ComprobanteCaja }) => createPortal(
  <div className="ticket-print-only">
    <p className="centro bold titulo">SISTEMA MANTSILA</p>
    <p className="centro bold">{c.tipo === 'RI' ? 'RECIBO DE INGRESO' : 'RECIBO DE EGRESO'}</p>
    <p className="centro bold titulo">{c.numero}</p>
    {c.anulado && <p className="centro bold titulo">*** ANULADO ***</p>}
    <hr />
    <p><span className="bold">Fecha:</span> {new Date(c.fecha).toLocaleString('es-PE')}</p>
    <p><span className="bold">Caja:</span> {NOMBRE_CAJA[c.caja || ''] || c.caja || '-'}</p>
    <p><span className="bold">Concepto:</span> {c.concepto || '-'}</p>
    {c.categoria && <p><span className="bold">Categoría:</span> {c.categoria}</p>}
    <p><span className="bold">Forma:</span> {(c.metodo_pago || 'efectivo').toUpperCase()}</p>
    <p><span className="bold">Registró:</span> {c.usuario ? c.usuario.charAt(0).toUpperCase() + c.usuario.slice(1) : '-'}</p>
    <hr />
    <p className="centro bold titulo">S/ {Number(c.monto).toFixed(2)}</p>
    <hr />
    {c.anulado && (
      <p>Anulado {c.anulado_en ? new Date(c.anulado_en).toLocaleString('es-PE') : ''} por {c.anulado_por || '-'}: {c.anulado_motivo || ''}</p>
    )}
    <p>&nbsp;</p><p>&nbsp;</p>
    <p className="centro">______________________</p>
    <p className="centro">{c.tipo === 'RI' ? 'Entregó (paga)' : 'Recibió (cobra)'}</p>
    <p>&nbsp;</p><p>&nbsp;</p>
    <p className="centro">______________________</p>
    <p className="centro">{c.tipo === 'RI' ? 'Recibió (caja)' : 'Entregó (caja)'}</p>
    <hr />
    <p className="centro">Conserve este comprobante</p>
  </div>,
  document.body
);

export default ComprobanteTicket;
